import { render } from "./lizhi.vue?vue&type=template&id=06c788d7&scoped=true"
import script from "./lizhi.vue?vue&type=script&lang=js"
export * from "./lizhi.vue?vue&type=script&lang=js"

import "./lizhi.vue?vue&type=style&index=0&id=06c788d7&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c788d7"]])

export default __exports__